// extracted by mini-css-extract-plugin
export var statItem = "_jr-1";
export var statsRow = "_jr-0";